import { TableColumn } from 'react-data-table-component';

// eslint-disable-next-line no-shadow
export enum FormInputName {
  transactionCode = 'transactionCode',
}

export interface TicketDataRow {
  event: string;
  section: string;
  ticket: string;
  status: string;
  used: string;
}

export const ticketColumns: TableColumn<TicketDataRow>[] = [
  {
    name: 'Evento',
    selector: row => row.event,
  },
  {
    name: 'Setor',
    selector: row => row.section,
  },
  {
    name: 'Ingresso',
    selector: row => row.ticket,
  },
  {
    name: 'Status',
    selector: row => row.status,
  },
  {
    name: 'Utilizado',
    selector: row => row.used,
  },
];

export const transferColumns: TableColumn<TicketDataRow>[] = [
  {
    name: 'Evento',
    selector: row => row.event,
  },
  {
    name: 'Setor',
    selector: row => row.section,
  },
  {
    name: 'Ingresso',
    selector: row => row.ticket,
  },
  {
    name: 'Utilizado',
    selector: row => row.used,
  },
];
